/**
 * Concordancia en castellano: «1 pedido», «2 pedidos».
 * El plural por defecto añade una s al singular.
 */

import { formatNumber } from './format-es';

export function esNoun(count: number, singular: string, plural = `${singular}s`): string {
    return Math.abs(count) === 1 ? singular : plural;
}

export function esCount(count: number, singular: string, plural?: string): string {
    return `${formatNumber(count)} ${esNoun(count, singular, plural)}`;
}
